import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/useAuthStore';
import { isOrdersStaff } from '../utils/ordersStaff';

/**
 * Guarda das telas de OPERAÇÃO do módulo de Pedidos (Kanban, clientes, detalhe
 * do pedido). Aceita a equipe, não só admin — ver `isOrdersStaff`.
 *
 * As demais rotas de `/admin` continuam sob AdminRoute: quem opera pedidos não
 * ganha empresas, billing, módulos nem cadeias de provider.
 */
const OrdersStaffRoute: React.FC = () => {
  const { user, isLoading } = useAuthStore();
  const navigate = useNavigate();
  const allowed = isOrdersStaff(user);

  useEffect(() => {
    if (!isLoading && !allowed) {
      navigate('/', { replace: true });
    }
  }, [allowed, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-snapfy-bg flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#7063f7]"></div>
      </div>
    );
  }

  return allowed ? <Outlet /> : null;
};

export default OrdersStaffRoute;
